export default __webpack_public_path__ + "static/media/c-basic.23629738.png";